<div class="container mx-auto px-4 py-6">
  <div class="mb-6">
    <h1 class="text-3xl font-bold text-gray-800">Registrar Pagamento Manual</h1>
    <p class="text-gray-600 mt-2">PIX/Transferência fora do gateway</p>
  </div>

  <div class="bg-white rounded-lg shadow p-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Fornecedor ID *</label>
        <input [(ngModel)]="fornecedorId" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="GUID do fornecedor">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Valor (R$) *</label>
        <input [(ngModel)]="valor" type="number" step="0.01" class="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="79.90">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Método de Pagamento *</label>
        <select [(ngModel)]="metodoPagamento" class="w-full px-3 py-2 border border-gray-300 rounded-md">
          <option value="PIX">PIX</option>
          <option value="Transferência">Transferência</option>
        </select>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Data de Recebimento *</label>
        <input [(ngModel)]="dataRecebimento" type="date" class="w-full px-3 py-2 border border-gray-300 rounded-md">
      </div>
      <div class="md:col-span-2">
        <label class="block text-sm font-medium text-gray-700 mb-1">Comprovante (URL)</label>
        <input [(ngModel)]="comprovante" type="url" class="w-full px-3 py-2 border border-gray-300 rounded-md" placeholder="https://...">
      </div>
      <div class="md:col-span-2">
        <label class="block text-sm font-medium text-gray-700 mb-1">Observações</label>
        <textarea [(ngModel)]="observacoes" rows="3" class="w-full px-3 py-2 border border-gray-300 rounded-md"></textarea>
      </div>
    </div>
    <div class="mt-6">
      <button (click)="submit()" [disabled]="loading" class="px-4 py-2 bg-green-600 text-white rounded-md">
        <span *ngIf="loading" class="inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></span>
        Registrar Pagamento
      </button>
    </div>
  </div>
</div>
